export default __webpack_public_path__ + "static/media/about_img.50475f7d.png";